import { createFileRoute } from '@tanstack/react-router'

import OrdersPage from '@/views/orders/pages/orders.page'

export const Route = createFileRoute('/phong-nha/orders/')({
  component: OrdersPage,
})
